module.exports = __webpack_public_path__ + "static/chaingpt-36557aafe87157935ba97f2d5da26a74.png";